<template>
	<div></div>
</template>

<script>
// const USERSNAP_GLOBAL_API_KEY = '76da6e4b-b111-4bcb-9719-a01f169271ed';
export default {
	name: 'Usersnap',
	created() {
		window.onUsersnapCXLoad = function(api) {
			api.init();
		};
		const script = document.createElement('script');
		script.defer = 1;
		script.src = 'https://widget.usersnap.com/global/load/f038b4bc-fd03-4b3f-8053-83434864e0d9?onload=onUsersnapCXLoad';
		document.getElementsByTagName('head')[0].appendChild(script);
	},
};
</script>

<style scoped></style>
